export const endSearch = (state = {}) => {
  return {
    ...state,
    allSearchResults: {},
    searchInput: '',
    allSearchMeta: {},
    recentSearches: [],
  };
};
